import { Injectable, inject } from '@angular/core';
import { DfEventData, DfEventService } from '@df/core/service/df-event';
import { GtmDataService } from '@df/module-gtm/service/gtm-data.service';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import { Nexus } from '@tomandco/nexus-api-types';
import './gtm-event-add-shipping-info';

@Injectable({
    providedIn: 'root'
})
export class GtmEventAddShippingInfoTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * GTM basket service
     */
    private gtmDataService = inject(GtmDataService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup event listener
     */
    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'dfCheckoutChange' && event.data.type === 'shippingMethod') {
                this.dispatch(event, event.data.quote);
            }
        });
    }

    /**
     * Dispatch event
     */
    private async dispatch(trigger: DfEventData, checkoutData: Nexus.Api.Checkout.Load.Response['checkout']) {
        return this.gtmService.dispatch({
            event: 'add_shipping_info',
            triggerContext: {
                trigger,
                checkoutData
            },
            ecommerce: {
                ...(await this.gtmDataService.getEventData(
                    this.gtmDataService.getBasketItems(),
                    this.gtmDataService.getBasketExtras(checkoutData)
                ))
            }
        });
    }
}
